import { Link, useLocation } from 'react-router-dom'
import { LayoutDashboard, Loader2, LogOut, Stethoscope, UserPlus } from 'lucide-react'
import { useAuth } from '@/contexts/AuthContext'

const NAV = [
  { href: '/admin', label: 'Dashboard', icon: LayoutDashboard, exact: true },
  { href: '/admin/medicos', label: 'Médicos', icon: Stethoscope },
  { href: '/admin/medicos/novo', label: 'Novo médico', icon: UserPlus },
]

function isActive(pathname: string, href: string, exact?: boolean) {
  if (exact) return pathname === href
  return pathname === href || pathname.startsWith(`${href}/`)
}

export default function AdminShell({ children }: { children: React.ReactNode }) {
  const { loading, user, perfil, signOut } = useAuth()
  const location = useLocation()
  const pathname = location.pathname

  if (loading) {
    return (
      <div className="public-screen">
        <Loader2 size={28} style={{ animation: 'spin 1s linear infinite', color: 'var(--muted)' }} aria-hidden />
      </div>
    )
  }

  if (!user) return null

  return (
    <div style={{ display: 'flex', minHeight: '100dvh', background: 'var(--bg)' }}>
      <aside
        style={{
          width: 240, flexShrink: 0, borderRight: '1px solid var(--border)',
          background: 'var(--card)', padding: '20px 14px', display: 'flex', flexDirection: 'column', gap: 8,
        }}
      >
        <div style={{ padding: '4px 10px 16px' }}>
          <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: '0.06em', color: 'var(--primary)', textTransform: 'uppercase' }}>
            Operação Soumed
          </div>
          <div style={{ fontWeight: 800, fontSize: 17, marginTop: 4 }}>Admin plataforma</div>
          <div style={{ fontSize: 12, color: 'var(--muted)', marginTop: 2 }}>Médico 360</div>
        </div>

        <nav style={{ display: 'flex', flexDirection: 'column', gap: 4, flex: 1 }}>
          {NAV.map(item => {
            const Icon = item.icon
            const active = isActive(pathname, item.href, item.exact)
            return (
              <Link
                key={item.href}
                to={item.href}
                style={{
                  display: 'flex', alignItems: 'center', gap: 10, padding: '10px 12px', borderRadius: 10,
                  fontSize: 14, fontWeight: active ? 700 : 500,
                  background: active ? 'var(--primary-soft)' : 'transparent',
                  color: active ? 'var(--primary-deep)' : 'var(--text-secondary)',
                }}
              >
                <Icon size={17} aria-hidden />
                {item.label}
              </Link>
            )
          })}
        </nav>

        <div style={{ borderTop: '1px solid var(--border)', paddingTop: 12, fontSize: 13 }}>
          <div style={{ padding: '0 10px 8px', color: 'var(--muted)' }}>{perfil?.nome ?? user.email}</div>
          <button
            type="button"
            className="btn-secondary"
            style={{ width: '100%', justifyContent: 'flex-start', gap: 8 }}
            onClick={() => signOut()}
          >
            <LogOut size={16} aria-hidden /> Sair
          </button>
        </div>
      </aside>

      <main style={{ flex: 1, padding: '24px 28px', maxWidth: 960, overflow: 'auto' }}>
        {children}
      </main>
    </div>
  )
}
